import React from 'react';
import { Product } from '../../types/product';

interface RibbonSelectorProps {
  ribbons: Product[];
  selectedRibbon: Product | null;
  onSelectRibbon: (ribbon: Product | null) => void;
}

const RibbonSelector: React.FC<RibbonSelectorProps> = ({
  ribbons,
  selectedRibbon,
  onSelectRibbon,
}) => {
  if (ribbons.length === 0) {
    return null;
  }

  return (
    <div style={{
      backgroundColor: '#FFFFFF',
      border: '1px solid #E5E7EB',
      borderRadius: '12px',
      padding: '16px',
      marginBottom: '16px'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px'
      }}>
        <label style={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#1A1A1A',
          fontFamily: 'Montserrat, sans-serif'
        }}>
          Add Ribbon (Optional):
        </label>
        {selectedRibbon && (
          <button
            onClick={() => onSelectRibbon(null)}
            style={{
              background: 'none',
              border: 'none',
              color: '#EF4444',
              fontSize: '12px',
              fontWeight: 600,
              cursor: 'pointer',
              padding: '4px 8px',
              textDecoration: 'underline'
            }}
          >
            Clear
          </button>
        )}
      </div>

      {/* Ribbon Grid */}
      <div style={{
        display: 'flex',
        gap: '12px',
        overflowX: 'auto',
        paddingBottom: '8px'
      }}>
        {ribbons.map((ribbon) => {
          const isSelected = selectedRibbon?.id === ribbon.id;
          const imageSrc = ribbon.images && ribbon.images.length > 0
            ? ribbon.images[0]
            : '/assets/products/placeholder.png';

          return (
            <div
              key={ribbon.id}
              onClick={() => onSelectRibbon(isSelected ? null : ribbon)}
              style={{
                minWidth: '100px',
                cursor: 'pointer',
                border: isSelected ? '3px solid #1976D2' : '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: '8px',
                backgroundColor: isSelected ? '#E3F2FD' : '#FFFFFF',
                transition: 'all 0.2s',
                boxShadow: isSelected ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                position: 'relative'
              }}
            >
              {/* Ribbon Image */}
              <div style={{
                width: '84px',
                height: '84px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '8px',
                backgroundColor: '#F9FAFB',
                borderRadius: '4px',
                overflow: 'hidden'
              }}>
                <img
                  src={imageSrc}
                  alt={ribbon.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = '/assets/products/placeholder.png';
                  }}
                />
              </div>

              {/* Ribbon Name */}
              <div style={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#1A1A1A',
                textAlign: 'center',
                marginBottom: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {ribbon.name}
              </div>

              {/* Ribbon Price */}
              <div style={{
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#10B981',
                textAlign: 'center'
              }}>
                {ribbon.price !== null ? `€${ribbon.price.toFixed(2)}` : 'Price TBA'}
              </div>
            </div>
          );
        })}
      </div>

      {/* Selected Ribbon Info */}
      {selectedRibbon && (
        <div style={{
          marginTop: '12px',
          padding: '8px',
          backgroundColor: '#E3F2FD',
          borderRadius: '8px',
          fontSize: '12px',
          color: '#1976D2',
          textAlign: 'center'
        }}>
          Selected: {selectedRibbon.name}
        </div>
      )}
    </div>
  );
};

export default RibbonSelector;
